import { render, staticRenderFns } from "./CompanyFolders.vue?vue&type=template&id=f819611e&"
import script from "./CompanyFolders.vue?vue&type=script&lang=js&"
export * from "./CompanyFolders.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFolders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports